export default __webpack_public_path__ + "static/media/thothamonsstronghold.58e97bc3.jpg";